import React, {useEffect} from "react";
import {withStyles,Box} from "@material-ui/core/";
import { makeStyles } from "@material-ui/styles";
import IconLogo from "./assets/images/logo.png";
import { useHistory, useLocation } from "react-router-dom";
import {connect} from "react-redux";
import {Link as RouterLink} from 'react-router-dom';
import Link from '@material-ui/core/Link';
import {styles} from "../../home-screen/assets/styles";

const useStyles = makeStyles({
  "@global": {
    "html, body": {
      margin: 0,
      padding: 0,
      backgroundColor: "#e5e5e5"
    }
  },
  root: {
    backgroundColor: "#434343",
    boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
    position: "relative",
    zIndex: 100,
    '& *': {
      fontFamily: "'Meiryo', 'Hiragino Sans', serif !important"
    }
  },
  logoDesc: {
    color: '#fff',
  },
  brandLogoRoot: {
    display:'inline-flex',
    alignItems: 'center',
    height: 70,
    marginLeft: -10,
    "& a": {
      "&:first-child": {
        display: 'block',
        width: 170,
        height: 70,
      },
      "&:nth-child(2)": {
        textDecoration: 'none',
        color: '#e0e0e0',
        fontSize: 12,
      }
    }
  },
  secondaryNav: {
    position: 'absolute',
    right: 0,
    top: 0,
    textAlign: 'right',
    minWidth: 400,
    "& ul": {
      listStyle: 'none',
      display: 'inline-block',
      padding: 0,
      margin: 0,
      "& li": {
        display: "inline-block",
        paddingLeft: 7,
        marginLeft: 7,
        "&:first-child": {
          border: 'none',
        },
      },
      "& > li a": {
        fontSize: 10,
        color: '#e0e0e0',
        fontWeight: "bold",
        textDecoration: "none",
        display: "inline-block",
      }
    }
  },
});

function goNext () {
  window.history.go(1);
}

const Header = ({ isMaintenance }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const ResidentAccessUrl: any = localStorage.getItem("ResidentAccessUrl");

  const checkRedirect = (pathname) => {
    const pageName: any[] = ['/register-room', '/booking-calendar', '/register-option', '/booking-information', '/finish-register-room'];
    const checkLocalPage = pageName.some(x => x === pathname);

    if (checkLocalPage) {
      window.history.pushState(null, '', pathname);
      window.onpopstate = goNext;
    } else {
      window.onpopstate = () => {};
    }
  };

  useEffect(() => {
    if (isMaintenance) {
      history.push('/maintenance')
    }
  }, [isMaintenance]);

  checkRedirect(pathname);
  return (
    <Box component="header" width={1} height={70} className={classes.root}>
      <Box maxWidth={980} margin="0 auto" position="relative">
        <Box className={classes.brandLogoRoot}>
          <Link href="https://www.panasonic.com/jp/home.html" target="_blank">
            <img src={IconLogo} />
          </Link>
          <RouterLink to={ResidentAccessUrl}>工事予約ネット </RouterLink>
        </Box>
        <Box className={classes.secondaryNav}>
          <Box component="nav">
            <ul>
              <li><a href="https://www.panasonic.com/jp/home.html" target="_blank">パナソニック・ホーム</a></li>
            </ul>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export const mapStateToProps = state => ({
  isMaintenance: state.maintenance.isMaintenance,
});


export default connect(
  mapStateToProps
)(withStyles(styles)(Header));
